import { createElement } from "react";
import { Plus, Trash2 } from "lucide-react";
import { JsonEditor } from "../JsonEditor";

export const inp = "w-full rounded-lg border border-input bg-white px-2.5 py-1.5 text-sm outline-none focus:ring-2 focus:ring-[#FF7A00]";
export const label = (k) => String(k).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
export const isObj = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
export const isNested = (v) => isObj(v) || Array.isArray(v);

function blankLike(v) {
  if (typeof v === "number") return 0;
  if (typeof v === "boolean") return false;
  if (Array.isArray(v)) return [];
  if (isObj(v)) return {};
  return "";
}

export function Scalar({ value, onChange, testid }) {
  if (typeof value === "boolean") {
    return (
      <label className="inline-flex items-center gap-2 text-sm">
        <input data-testid={testid} type="checkbox" checked={value} onChange={(e) => onChange(e.target.checked)} className="accent-[#FF7A00] w-4 h-4" />
        {value ? "Activo" : "Inactivo"}
      </label>
    );
  }
  if (typeof value === "number") {
    return <input data-testid={testid} className={inp} type="number" step="any" value={value} onChange={(e) => onChange(e.target.value === "" ? 0 : Number(e.target.value))} />;
  }
  if (value === null) {
    return <input data-testid={testid} className={inp} value="" placeholder="(vacío)" onChange={(e) => onChange(e.target.value || null)} />;
  }
  if (String(value).length > 80) {
    return <textarea data-testid={testid} className={`${inp} min-h-[80px]`} value={value} onChange={(e) => onChange(e.target.value)} />;
  }
  return <input data-testid={testid} className={inp} value={value} onChange={(e) => onChange(e.target.value)} />;
}

export function Cell({ value, onChange, path, testid }) {
  if (isNested(value)) return createElement(JsonEditor, { value, onChange, path, compact: true });
  return createElement(Scalar, { value, onChange, testid });
}

function ObjectRows({ value, onChange, path }) {
  const cols = Object.keys(value[0]);
  const setCell = (i, c, v) => onChange(value.map((r, j) => (j === i ? { ...r, [c]: v } : r)));
  const remove = (i) => onChange(value.filter((_, j) => j !== i));
  const add = () => onChange([...value, Object.fromEntries(cols.map((c) => [c, blankLike(value[0][c])]))]);
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="text-left text-[10px] uppercase text-[#8A8A8A]">
            {cols.map((c) => <th key={c} className="py-1 pr-2">{label(c)}</th>)}
            <th />
          </tr>
        </thead>
        <tbody>
          {value.map((row, i) => (
            <tr key={i} className="border-t border-border">
              {cols.map((c) => (
                <td key={c} className="py-1 pr-2 min-w-[120px] align-top">
                  {createElement(Cell, { value: row[c], onChange: (v) => setCell(i, c, v), path: `${path}.${i}.${c}`, testid: `json-${path}-${i}-${c}` })}
                </td>
              ))}
              <td className="py-1">
                <button data-testid={`json-${path}-remove-${i}`} onClick={() => remove(i)} className="text-[#8A8A8A] hover:text-red-600"><Trash2 size={13} /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button data-testid={`json-${path}-add`} onClick={add} className="mt-2 text-xs text-[#FF7A00] font-semibold inline-flex items-center gap-1"><Plus size={12} /> agregar fila</button>
    </div>
  );
}

export function ArrayEditor({ value, onChange, path }) {
  if (value.length > 0 && value.every(isObj)) return createElement(ObjectRows, { value, onChange, path });
  const add = () => onChange([...value, value.length ? blankLike(value[0]) : ""]);
  return (
    <div className="space-y-1">
      {value.map((v, i) => (
        <div key={i} className="flex gap-2 items-center">
          {createElement(Cell, { value: v, onChange: (nv) => onChange(value.map((x, j) => (j === i ? nv : x))), path: `${path}.${i}`, testid: `json-${path}-${i}` })}
          <button onClick={() => onChange(value.filter((_, j) => j !== i))} className="text-[#8A8A8A] hover:text-red-600"><Trash2 size={13} /></button>
        </div>
      ))}
      <button data-testid={`json-${path}-add`} onClick={add} className="text-xs text-[#FF7A00] font-semibold inline-flex items-center gap-1"><Plus size={12} /> agregar</button>
    </div>
  );
}
